/* eslint-disable @typescript-eslint/no-explicit-any */

import debounce from '../../utils/debounce'
import { generateId } from '../../utils/unique-id'

// eslint-disable-next-line
const traceLog = (...args: any[]) => {
  if (
    Array.isArray(args) &&
    typeof args[0] === 'string' &&
    args[0].includes('------') // use '------' to turn off the tracing
  ) {
    // eslint-disable-next-line
    console.groupCollapsed(...args)
    // eslint-disable-next-line
    console.trace()
    // eslint-disable-next-line
    console.groupEnd()
  }
}

class Subject<T extends Function, A = undefined> {
  private observers: T[] = []
  private debouncePeriod: number
  private debounceOnLoad: boolean
  private initialNotification: boolean
  public name: string

  constructor(
    name?: string,
    options?: { debounceOnLoad?: boolean; debouncePeriod?: number }
  ) {
    this.name = generateId(`${name ? name : 'subject'}-`)
    this.debouncePeriod =
      options?.debouncePeriod ?? (options?.debounceOnLoad ? 166 : 0)
    this.debounceOnLoad = options?.debounceOnLoad ?? false
    this.initialNotification = true
    traceLog(`[${this.name}]: constructed`, this)
  }

  public attach(observer: T): void {
    this.observers.push(observer)
    traceLog(`[${this.name}]: attached an observer`, this)
  }
  public detach(observer: T): void {
    traceLog(`[${this.name}]: detached an observer`, this)
    this.observers = this.observers.filter(o => o !== observer)
  }

  public notify(args?: A): void {
    traceLog(`[${this.name}]: notifying these observers`, this.observers)
    if (this.debounceOnLoad && this.initialNotification) {
      this.initialNotification = false
      debounce(
        (...args: any[]) => this.observers.forEach(o => o(...args)),
        this.debouncePeriod
      )(args)
      this.debouncePeriod = 0
    } else if (this.debouncePeriod) {
      debounce(
        (...args: any[]) => this.observers.forEach(o => o(...args)),
        this.debouncePeriod
      )(args)
    } else {
      this.observers.forEach(o => o(args))
    }
  }
}

export default Subject
